import {useEffect, useRef} from 'react';

/** Calls `onEscape` when the Escape key is pressed while `active` is true.
 *  Used to exit fullscreen panels in the IRP workbook analysis tabs. The callback
 *  is held in a ref so the listener only re-binds when `active` flips, not on every
 *  render (matching the hand-rolled effects this replaces). */
export function useEscapeKey(active: boolean, onEscape: () => void): void {
    const onEscapeRef = useRef(onEscape);
    onEscapeRef.current = onEscape;

    useEffect(() => {
        if (!active) return;
        const onKeyDown = (e: KeyboardEvent): void => {
            if (e.key === 'Escape') onEscapeRef.current();
        };
        document.addEventListener('keydown', onKeyDown);
        return (): void => document.removeEventListener('keydown', onKeyDown);
    }, [active]);
}
